import { SlideshowSelectEvent } from '@theme/events';

/**
 * Shows the alt text of the currently visible product gallery image
 * between the main image and the thumbnail slider.
 */
class SlideshowVariantTitle extends HTMLElement {
  /** @type {HTMLElement | null} */
  #slideshow = null;

  connectedCallback() {
    this.#slideshow = this.closest('slideshow-component');
    this.#slideshow?.addEventListener(SlideshowSelectEvent.eventName, this.#onSlideshowSelect);
    this.#syncFromCurrentSlide();
  }

  disconnectedCallback() {
    this.#slideshow?.removeEventListener(SlideshowSelectEvent.eventName, this.#onSlideshowSelect);
    this.#slideshow = null;
  }

  /**
   * @param {SlideshowSelectEvent} event
   */
  #onSlideshowSelect = (event) => {
    if (event.target !== this.#slideshow) return;
    this.#applyAlt(event.detail.slide);
  };

  #syncFromCurrentSlide() {
    const currentSlide =
      this.#slideshow?.querySelector('slideshow-slide[aria-hidden="false"]') ||
      this.#slideshow?.querySelector('slideshow-slide');
    this.#applyAlt(currentSlide);
  }

  /**
   * @param {Element | null | undefined} slide
   */
  #applyAlt(slide) {
    if (!slide) return;

    const captionHost = slide.querySelector('[data-caption]');
    const alt = (captionHost?.getAttribute('data-caption') || '').trim();
    const text = this.querySelector('.slideshow-variant-caption-text');
    if (text) {
      text.textContent = alt;
      text.setAttribute('aria-hidden', alt ? 'false' : 'true');
    }
  }
}

if (!customElements.get('slideshow-variant-title')) {
  customElements.define('slideshow-variant-title', SlideshowVariantTitle);
}
